<template>
  <vs-popup title="Resumen de deudas" :active.sync="isPromptActiveLocal">


    <vs-table ref="table" :data="allSummaries" noDataText="No hay deudas pendientes">

      <!-- SALE TITLES -->
      <template slot="thead">
        <vs-th>Deuda</vs-th>
        <vs-th>Nombre</vs-th>
        <vs-th>Saldar</vs-th>
      </template>

      <!-- SALE ITEMS -->
      <template slot-scope="{data}">
        <vs-tr v-if="tr.total" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="autoWidth">${{ showPrice(tr.total) }}</vs-td>
          <vs-td>{{ tr.employeeFullName }}</vs-td>
          <vs-td class="autoWidth">
            <vs-switch v-model="tr.isPayed" @change="payAllOf(tr)"/>
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>  <!-- Sale table -->

  </vs-popup>
</template>

<script>
export default {
  props: {
    isPromptActive: { type: Boolean, required: true, },
    EmployeesSales: { type: Array, required: true, },
  }, // PROPS
  data() {
    return {
      avoidDuplicatesCounter: 0,
      allSummaries: [],
      selectedCities: [],
    }; // return DATA
  }, // DATA
  computed: {
    isPromptActiveLocal: {
      get() {
        this.showSummary();
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit('closePrompt');
        }
      }
    },
  }, // COMPUTED
  watch: {
  }, // WATCH
  created() {
  }, // CREATED

  methods: {
    // copyList
    // payAllOf
    // showSummary
    copyList(Item) {
      // LA IDEA ERA GENERAR UN RESUMEN DE LOS PRODUCTOS QUE SE LLEVARON
      // Eczampl:
      // 21/03/19
      //   1x Fideos
      //   3x Salsa de tomate
      // 22/03/19
      //   1x Chocolate negro
      let text = '';
      for (let Sale of this.EmployeesSales) {
        if (Sale.buyerEmployeeID == Item.employeeID) {
          text += ``;
          // ESTO ES ALTO MAMBITO, ASÍ QUE QUEDA ABANDONADO
        }
      }
      this.myNotify('success', 'Éxito', `Lista de deudas de <b>${Item.employeeFullName}</b> copiada`);
    },
    payAllOf(Item) {
      if (this.avoidDuplicatesCounter++ % 2) return;
      this.myNotify('success', 'Éxito', `Se han saldados las deudas de <b>${Item.employeeFullName}</b>`);
      for (let Sale of this.EmployeesSales) {
        if (Sale.buyerEmployeeID == Item.employeeID) {
          Sale.isPayed = true;
          let Params = {
            saleID: Sale.id,
            paymentDatetime: this.getActualDatetimeToDB(),
          }
          this.$emit('modifySaleDB', Params);
        }
      }
    },
    showSummary() {
      let allSummaries = [];
      let allEmployees = this.dataDB.employees;
      for (let Employee of allEmployees) {
        let newSummary = {
          employeeID: Employee.id,
          total: 0,
          isPayed: false,
          employeeFullName: Employee.name,
        }
        allSummaries.push(newSummary);
      }
      for (let Sale of this.EmployeesSales) {
        for (let Summary of allSummaries) {
          if (Sale.buyerEmployeeID == Summary.employeeID) {
            if (Sale.isPayed) break;
            Summary.total += +Sale.totalTotal;
            break;
          }
        }
      }
      this.allSummaries = allSummaries;
    },
  }, // METHODS
} // export default
</script>

<style lang="scss" scoped>
</style>
